import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from './Header';
import { setLastCampaignSummaryPage } from '../store/actions/route-actions';

const CampaignSummary = () => {
  const dispatch = useDispatch();


  useEffect(() => {

    dispatch(setLastCampaignSummaryPage('/campaign-summary'));
  }, []);

  return (
   <div>
     <Header />
  </div>
  )
}


export default CampaignSummary;
